export default __webpack_public_path__ + "static/media/Snd_LowerWSlidedown.bf783cf9.mp3";